import React, { Component } from 'react';
import styles from './index.less';
import { Cascader } from 'antd';
import cx from 'classnames';
import districtMaker from './district';

export default class AntdCascader extends Component {
  state = {
    text: '请选择省市'
  };

  onChange = (value, selectedOptions) => {
    this.setState({
      text: selectedOptions.map(o => o.label).join(', ')
    });
  };

  render() {
    const { className, onChange = f => f } = this.props;
    const finalOnChange = (value, selectedOptions) => {
      this.onChange(value, selectedOptions);
      onChange(value, selectedOptions);
    };
    return (
      <span className={className}>
        <Cascader
          expandTrigger="hover"
          options={districtMaker(2 /*联动的层级: 2表示省市，3表示省市区*/)}
          onChange={finalOnChange}
          popupClassName="district-menu"
        >
          <span className={styles.text}>{this.state.text}</span>
        </Cascader>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/district-select/index.js